import React, { useEffect, useRef } from 'react';
import { Container, Paper, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AccountDeletionComplete: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const hasLoggedOutRef = useRef(false);

  useEffect(() => {
    if (!hasLoggedOutRef.current) {
      logout();
      hasLoggedOutRef.current = true;
    }
  }, [logout]);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login', { replace: true });
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [navigate]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" gap={2}>
          <Typography variant="h5" component="h1">
            アカウント削除が完了しました
          </Typography>
          <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
            {[
              'データの削除及びサブスクリプションの解約が完了しました。',
              '手指衛生データ分析アプリのご利用まことにありがとうございました。',
            ].join('\n')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            5秒後にログイン画面へ移動します。
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default AccountDeletionComplete;
